import React, {PureComponent} from "react"

import {H6} from "@irati/ui/src/Typography"
import {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage} from "@irati/utils/lang"

import {Loader, DownloadCompleteSection, DownloadCompleteIcon} from "./styled"

interface Props {
  hasDownloaded: boolean,
  percent: number,
  downloadCompleteText?: string,
  downloadingText?: string
}

class ProgressLoader extends PureComponent<Props> {
  static defaultProps = {
    downloadCompleteText: "platform.downloadComplete",
    downloadingText: "platform.downloading"
  }

  render() {
    const {hasDownloaded, percent, downloadCompleteText, downloadingText} = this.props
    return (
      hasDownloaded ?
        <DownloadCompleteSection>
          <DownloadCompleteIcon icon={IconTypes.tick} marginRight />
          <FormattedMessage id={downloadCompleteText} />
        </DownloadCompleteSection> :
        <Flex>
          <Loader percent={percent} />
          <H6 marginLeft={1}><FormattedMessage id={downloadingText} /></H6>
        </Flex>
    )
  }
}

export default ProgressLoader
